import { isValidLatitude, isValidLongitude } from '@gorila-shared-ui/components';
import { Event } from '../types/gpt';

export const getValidEventPositions = (event: Event) => {
  const positions = event.alarms?.map((alarm) => {
    const lat = alarm.gpsLat;
    const lng = alarm.gpsLng;
    const hasValidPosition = !!lat && !!lng && isValidLatitude(lat) && isValidLongitude(lng);

    return hasValidPosition ? [lng, lat] : undefined;
  });
  const { cs } = event;
  if (cs && isValidLatitude(cs.latitude) && isValidLongitude(cs.longitude))
    positions.unshift([cs.longitude, cs.latitude]);
  return positions.filter((position) => position !== undefined) as number[][];
};
